var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMediumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_154801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.8564C20 12.5058 19.556 14.6549 19.0081 14.6549C18.4602 14.6549 18.0164 12.5064 18.0164 9.8564C18.0164 7.2064 18.4604 5.05786 19.0081 5.05786C19.5558 5.05786 20 7.2062 20 9.8564Z",
    fill: "url(#paint0_linear_1128_154801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4689 9.85646C17.4689 12.8142 16.2062 15.2129 14.6486 15.2129C13.091 15.2129 11.8282 12.8142 11.8282 9.85646C11.8282 6.8987 13.0908 4.5 14.6484 4.5C16.206 4.5 17.4688 6.89793 17.4688 9.85646",
    fill: "url(#paint1_linear_1128_154801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 9.85638C11.2812 12.9986 8.75578 15.5459 5.6407 15.5459C2.52561 15.5459 0 12.9981 0 9.85638C0 6.71469 2.52542 4.16663 5.6407 4.16663C8.75598 4.16663 11.2812 6.71411 11.2812 9.85638Z",
    fill: "url(#paint2_linear_1128_154801)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_154801",
    x1: 18.0164,
    y1: 9.8564,
    x2: 20,
    y2: 9.8564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_154801",
    x1: 11.8282,
    y1: 9.85646,
    x2: 17.4689,
    y2: 9.85646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_154801",
    x1: 0,
    y1: 9.85628,
    x2: 11.2812,
    y2: 9.85628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_154801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediumIcon);
export default __webpack_public_path__ + "static/media/SocialMediumIcon.b9b21a5e6bdd29c69ce2e28b151195ac.svg";
export { ForwardRef as ReactComponent };